import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import OurHistory from './components/OurHistory';
import Blogs from './components/Blogs';
import HistoryOfTemperatureTakers from './components/blogs/HistoryOfTemperatureTakers';
import BeyondTheTip from './components/blogs/BeyondTheTip';
import WhereWeSwim from './components/blogs/WhereWeSwim';
import Hypothermia from './components/blogs/Hypothermia';
import ResuscitationAndRescue from './components/blogs/ResuscitationAndRescue';
import SafetyGear from './components/blogs/SafetyGear';
import IcebergerSafety2026 from './components/blogs/IcebergerSafety2026';
import AndDidThoseFeet from './components/blogs/AndDidThoseFeet';
import PreSwimPersonalRiskAssessment from './components/blogs/PreSwimPersonalRiskAssessment';
import InductionHome from './components/induction/InductionHome';
import InductionModule from './components/induction/InductionModule';
import InductionAssessment from './components/induction/InductionAssessment';
import InductionComplete from './components/induction/InductionComplete';
import Enquiries from './components/Enquiries';
import Links from './components/Links';
import Footer from './components/Footer';
import './App.css';

import pierImage from './images/brighton-pier.jpeg';

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

const AppContent = () => {
  const headerStyle = {
    backgroundImage: `url(${pierImage})`,
  };

  return (
    <div className="App">
      <header className="home-header" style={headerStyle}>
        <div className="header-top">
          <div className="logo-container">
            <img src="/icebergers-logo.gif" alt="Icebergers Logo" className="main-logo" />
          </div>
          <Navbar />
        </div>
        <h2 className="splash-title">All year open water swimming</h2>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-history" element={<OurHistory />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/history-of-temperature-takers" element={<HistoryOfTemperatureTakers />} />
          <Route path="/blogs/beyond-the-tip" element={<BeyondTheTip />} />
          <Route path="/blogs/where-we-swim" element={<WhereWeSwim />} />
          <Route path="/blogs/hypothermia" element={<Hypothermia />} />
          <Route path="/blogs/resuscitation-and-rescue" element={<ResuscitationAndRescue />} />
          <Route path="/blogs/safety-gear" element={<SafetyGear />} />
          <Route path="/blogs/iceberger-safety-2026" element={<IcebergerSafety2026 />} />
          <Route path="/blogs/and-did-those-feet" element={<AndDidThoseFeet />} />
          <Route path="/blogs/PreSwimPersonalRiskAssessment" element={<PreSwimPersonalRiskAssessment />} />
          <Route path="/induction" element={<InductionHome />} />
          <Route path="/induction/module/:moduleId" element={<InductionModule />} />
          <Route path="/induction/assessment" element={<InductionAssessment />} />
          <Route path="/induction/complete" element={<InductionComplete />} />
          <Route path="/enquiries" element={<Enquiries />} />
          <Route path="/links" element={<Links />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;